<div aria-hidden="true" class="d-flex">
  <span
    class="d-none d-sm-flex ds-heading--xs text-muted me-2 secureText">{{'header.secureText' |
    cxTranslate}}</span>
  <em class="ds-icon ds-icon--big ds-icon--lock ds-color--grey-2"></em>
</div>
